import { RoleEnum } from '@zeus/index'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useBranding } from '~/helpers/branding/branding'
import { useAuth } from '~/helpers/store/auth'

function Footer() {
  const { t } = useTranslation()
  const { appName, footerText, brandingLocked } = useBranding()
  const isAdmin = useAuth(state => state.payload?.role === RoleEnum.Admin)

  return (
    <div className="p-5 text-center">
      {/* Plan gratuit : la mention « propulsé par » est imposée et remplace tout
          pied de page personnalisé — le white-label est réservé au payant (#155). */}
      {brandingLocked
        ? t('footer.free-org')
        : (footerText || `${appName} © ${new Date().getFullYear()}`)}
      {isAdmin && (
        <>
          <span className="mx-2 text-muted-foreground">·</span>
          <Link
            to="/back-office/roadmap"
            className="text-sm text-muted-foreground underline-offset-4 hover:underline"
          >
            {`v${__APP_VERSION__} — ${t('common.routing.roadmap')}`}
          </Link>
        </>
      )}
    </div>
  )
}

export default Footer
